import { Box } from "@chakra-ui/react";
import { TFeedCardBarSegment } from "src/components/feed-card/types/content";
import { EnumFeedCardBarSegmentColors } from "src/components/feed-card/types/enums";

export const FeedCardBarSegment = ({ color, value, label }: TFeedCardBarSegment) => (
    <Box display="inline-block" h="100%" w={`${value}%`} backgroundColor={getColorToken(color)} title={label} />
);

const getColorToken = (color: EnumFeedCardBarSegmentColors) => {
    switch (color) {
        case EnumFeedCardBarSegmentColors.Red:
            return "red.600";
        case EnumFeedCardBarSegmentColors.Green:
            return "green.600";
        default:
            return getFallbackColor({ color });
    }
};

const getFallbackColor = ({}: { color: never }) => "gray.600";
